<script setup>
import ChatBot from "@/components/ChatBot/components/ChatBot.vue";
import { useChatbotUI } from "@/components/ChatBot/composables/useChatBotUI";
import { computed, ref } from "vue";
import { getSubdomain } from "@/core/services/api.service";

const { toggleChatbot } = useChatbotUI();

const button = ref(null);
const handleChatBotToggle = () => {
  button.value.blur();
  toggleChatbot();
};

const showChatbot = computed(() => {
  const subdomain = getSubdomain(window.location.origin);
  const licenseIds = process.env.VUE_APP_HELPBOT_LICENSE_IDS
    ? process.env.VUE_APP_HELPBOT_LICENSE_IDS.split(",").map(item =>
      item.trim()
    )
    : [];

  return licenseIds.includes(subdomain);
});
</script>

<template>
  <div v-if="showChatbot">
    <button
      ref="button"
      class="btn btn-icon btn-outline-primary btn-gradient-outline"
      @click="handleChatBotToggle"
    >
      <i class="fal fa-sparkles" />
    </button>

    <ChatBot />
  </div>
</template>

<style scoped lang="scss">
$chatbot-primary-gradient-color: #3f46f2;
$chatbot-secondary-gradient-color: #c750c9;
$chatbot-white-color: #ffffff;

.btn-gradient-outline {
  border: 1.5px solid transparent;

  background-image: linear-gradient($chatbot-white-color, $chatbot-white-color),
    linear-gradient(
      135deg,
      $chatbot-primary-gradient-color,
      $chatbot-secondary-gradient-color
    );

  background-origin: border-box;
  background-clip: padding-box, border-box;

  .fal {
    background-clip: text;
    color: transparent;
    background: linear-gradient(
      135deg,
      $chatbot-primary-gradient-color,
      $chatbot-secondary-gradient-color
    );
    -webkit-background-clip: text;
    background-clip: text;
    transition: color 0.2s ease-in-out;
  }

  &:focus {
    background-image: linear-gradient(
        $chatbot-white-color,
        $chatbot-white-color
      ),
      linear-gradient(
        135deg,
        $chatbot-primary-gradient-color,
        $chatbot-secondary-gradient-color
      );
  }

  &:hover {
    background: repeating-linear-gradient(
        135deg,
        $chatbot-primary-gradient-color,
        $chatbot-secondary-gradient-color
      )
      0 100%;
    background-size: 200% auto;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation: wave 2s infinite;

    background-clip: border-box;
    border: none !important; // Background animation acts as border, so we need to remove it

    .fal {
      background: none;
      -webkit-background-clip: initial;
      background-clip: initial;
      color: $chatbot-white-color;
    }
  }
}
/* Button background */
@keyframes wave {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
